(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('DashboardService', DashboardService);

  DashboardService.$inject = ['$resource'];

  function DashboardService ($resource) {
    return $resource(apiUrl + '/dashboard/:id', { id: '@id' }, {
        	refresh: { url: apiUrl + '/dashboard/refresh/:id', method: 'POST', params: {}, isArray: false },
      filterBusinessManagement: { url: apiUrl + '/dashboard/dashboard-business-management', method: 'GET', params: {}, isArray: false },
        	loadFiltersBM: { url: apiUrl + '/dashboard/businessm-load-filters', method: 'GET', params: {}, isArray: false },
      filterOpSummary: { url: apiUrl + '/dashboard/dashboard-operational-summary', method: 'GET', params: {}, isArray: false },
      filterDetailsOpSummary: { url: apiUrl + '/dashboard/dashboard-details-opsummary', method: 'GET', params: {}, isArray: false },
      filterTeamManagement: { url: apiUrl + '/dashboard/dashboard-team-management', method: 'GET', params: {}, isArray: false },
      getMetabaseUrl: { url: apiUrl + '/dashboard/metabase/:dash', method: 'GET', params: {}, isArray: false },
      loadCounters: { url: apiUrl + '/dashboard/distribution-monitoring-load', method: 'GET', params: {}, isArray: false }
    });
  }
})();
